'use client';

import React from 'react';

import clsx from 'clsx';
import { Fab } from 'react-tiny-fab';

import List from '@/assets/list.svg';
import Mail from '@/assets/mail.svg';
import Phone from '@/assets/phone.svg';
import Question from '@/assets/Question2.svg';
import { useCountry } from '@/layers/core/deal/services/CountryContext';

function Link({
  href,
  style,
  children,
  className,
  text,
}: // text,
{
  href: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  className?: string;
  text: string;
}) {
  return (
    <a
      {...{ href, style }}
      className={clsx(
        className,
        'mr-1 flex h-12 w-12 items-center justify-center rounded-full shadow-lg'
      )}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
      <span className="sr-only">{text}</span>
    </a>
  );
}

function Fabs() {
  const { clean, contact, support, pqr } = useCountry();
  const color = clean ? '#2babe2' : '#FDD402';
  return (
    <Fab
      style={{ bottom: 24, right: 24, zIndex: 5 }}
      mainButtonStyles={{ background: color }}
      icon={<List />}
    >
      <Link text="Contact" href={contact} style={{ background: color }}>
        <Mail />
      </Link>
      <Link text="Support" href={support} style={{ background: color }}>
        <Phone />
      </Link>
      <Link text="PQRs" href={pqr} style={{ background: color }}>
        <Question />
      </Link>
    </Fab>
  );
}

export { Fabs };
